import { ApplyIfWorkerExistsParams, ApplyIfWorkerExistsResult } from '~/business/Apply/types';
import { callParseCloudFunctionProxy } from '~/utils/parse';

export type JobOfferApplyIfWorkerExistsParams = ApplyIfWorkerExistsParams & {
  jobOfferId: string;
};

export const jobOfferApplyIfWorkerExists = async ({
  businessUnit,
  ...body
}: JobOfferApplyIfWorkerExistsParams): Promise<ApplyIfWorkerExistsResult | undefined> => {
  const { data } = await callParseCloudFunctionProxy<ApplyIfWorkerExistsResult | undefined>(
    businessUnit,
    'WebJobOfferApplyIfWorkerExists',
    body,
  );
  return data;
};
